module.exports = __webpack_public_path__ + "media/img/pages/profile/ckw ger 3-4e3d024abac24a84b50dd24976cc788c.jpg";